import { NgClass } from '@angular/common';
import { Component, HostBinding, Input } from '@angular/core';
import { AiContentDisclaimerVariant } from '../ai-content.util';

@Component({
  selector: 'app-ai-content-disclaimer',
  templateUrl: './ai-content-disclaimer.component.html',
  styleUrls: ['./ai-content-disclaimer.component.scss'],
  imports: [NgClass]
})
export class AiContentDisclaimerComponent {
  @Input() variant: AiContentDisclaimerVariant = 'will';

  @Input() stackedBelowTip = false;

  @Input() @HostBinding('class.inline') inline = false;
}
